








































































































































































































































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import Modal from '@/components/Modal'
import MiniCalendar from '@ui/Calendar/MiniCalendar'

settings =
  name: 'AudienceListingConfirmedDatesModal'

  resources:
    audience_listing:
      resourceName: 'audience_listing'
      slug: 'audience_listings/:audienceListing.id'
      fetch: false

  vue:
    props: ['show', 'audienceListing']

    components: {
      LoadingIndicator,
      Modal,
      MiniCalendar,
    }

    data: ->
      searchConfirmedDate: ''
      selectedConfirmedDates: []

      searchPastDate: ''
      newPastDate:
        date: ''

    computed:
      creativeId: ->
        @audienceListing?.creative_id

      availabilityWindows: ->
        @audienceListing.availability_windows || []

      confirmedDates: ->
        @audienceListing.confirmed_dates || []

      datesTableData: ->
        tableData = []

        for item in @availabilityWindows
          continue unless @isDateInTheFuture item.date
          confirmedDate = @confirmedDates.find((d) -> d.date is item.date)
          status = confirmedDate?.status || 'unknown'
          tableData.push { date: item.date, status }

        for item in @confirmedDates
          isAlreadyAdded = tableData.some((d) -> d.date is item.date)
          continue if isAlreadyAdded

          isCanceled = item.status is 'canceled'
          isInTheFuture = @isDateInTheFuture item.date
          continue unless (isCanceled and isInTheFuture)
          tableData.push item

        tableData.filter((data) => !@searchConfirmedDate || dayjs(data.date).format('MM/DD/YYYY').includes(@searchConfirmedDate))

      pastDatesTableData: ->
        tableData = @confirmedDates.filter((item) =>
          isInThePast = !@isDateInTheFuture item.date
          isConfirmed = item.status is 'confirmed'
          isInThePast and isConfirmed
        )
        tableData.filter((data) => !@searchPastDate || dayjs(data.date).format('MM/DD/YYYY').includes(@searchPastDate))

      calendarSeasons: ->
        @audienceListing.calendar_seasons || []

      optionsForCalendar: ->
        initialDate: new Date(@availabilityWindows[0].date)
        selectable: false
        dayCellClassNames: () => ['disabled']

    methods:
      hiClose: ->
        @searchConfirmedDate = ''
        @selectedConfirmedDates = []
        @searchPastDate = ''
        @newPastDate =
          date: ''
        @$emit('close')

      hiConfirmDates: (dates) ->
        payload = { dates }
        @triggerResource 'audience_listing', 'confirm_availability_windows', payload

      hiResetDates: (dates) ->
        payload = { dates }
        @triggerResource 'audience_listing', 'reset_availability_windows', payload

      hiCancelDates: (dates) ->
        payload = { dates }
        @triggerResource 'audience_listing', 'cancel_availability_windows', payload

      hiSelectedDatesChange: (dates) ->
        @selectedConfirmedDates = dates

      hiAddConfirmedPastDate: ->
        return unless @newPastDate.date
        payload = { date: @newPastDate.date, status: 'confirmed' }
        @confirmedDates.push payload
        @triggerResource 'audience_listing', 'add_confirmed_past_date', payload
      onAudienceListingAddConfirmedPastDate: ->
        @newPastDate.date = ''

      hiRemoveDate: (row) ->
        payload = { date: row.date, status: row.status }
        @triggerResource 'audience_listing', 'remove_confirmed_past_date', payload

      isDateInTheFuture: (date) ->
        dayjs(date).isAfter dayjs()

      isNewPastDateDisabled: (date) ->
        dateStr = dayjs(date).format 'YYYY-MM-DD'
        oneYearAgo = dayjs().subtract 1, 'year'
        outOfRange = !dayjs(date).isBetween oneYearAgo, dayjs()
        isExistingDate = @confirmedDates.some((d) -> d.date is dateStr)
        isExistingDate || outOfRange

export default VueOptions.vue settings
